import { render } from "./WizardIntro.vue?vue&type=template&id=4edf5740"
import script from "./WizardIntro.vue?vue&type=script&lang=js"
export * from "./WizardIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/wizard/WizardIntro.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4edf5740"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4edf5740', __exports__)) {
    api.reload('4edf5740', __exports__)
  }
  
  module.hot.accept("./WizardIntro.vue?vue&type=template&id=4edf5740", () => {
    api.rerender('4edf5740', render)
  })

}


export default __exports__